import { useQuery } from '@tanstack/react-query';

import { getClaimsAsParty, type GetClaimsAsPartyResponse } from 'wg-api-sdk';

import wgApi from '@/lib/api/wgApi';
import type { QueryOptions } from '@/types/react-query';

import type { ClaimStatus } from '../../types';

import queryKeys from './../queryKeys';

export default function useClaims(
  partyId: string,
  filter?: { status?: ClaimStatus[]; q?: string },
  options?: QueryOptions<GetClaimsAsPartyResponse['items']>,
) {
  return useQuery({
    queryKey: queryKeys.list(partyId, filter),
    queryFn: async () => {
      const result = await getClaimsAsParty(
        {
          path: { party_id: partyId },
          query: { status: filter?.status ?? [], q: filter?.q },
        },
        wgApi,
      );

      return result.items;
    },
    ...options,
  });
}
